import { combineReducers } from 'redux';
import * as constants from './actions';

export const COUNTRY = 'COUNTRY';
export const REGION = 'REGION';
export const AREA = 'AREA';
export const TERRITORY = 'TERRITORY';

const selectedState = (state = null, action) => {
  switch (action.type) {
    case constants.FETCH_SND_COUNTRY_DETAILS_SUCCESS:
      return COUNTRY;
    case constants.FETCH_SND_REGION_DETAILS_SUCCESS:
      return REGION;
    case constants.FETCH_SND_AREA_DETAILS_SUCCESS:
      return AREA;
    case constants.FETCH_SND_TERRITORY_DETAILS_SUCCESS:
      return TERRITORY;
    default:
      return state;
  }
};

const filteringState = (
  state = { ...constants.INIT_FILTERING_STATE, distribution_house: true },
  action
) => {
  switch (action.type) {
    case constants.CHANGE_FILTERING_STATE:
      return action.payload;
    default:
      return state;
  }
};

const countryDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_SND_COUNTRY_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const clusterDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_SND_REGION_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const areaDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_SND_AREA_DETAILS_SUCCESS:
      return action.payload;
    case constants.FETCH_SND_REGION_DETAILS_REQUEST:
      return {};
    default:
      return state;
  }
};

const cbThanaDetails = (state = {}, action) => {
  switch (action.type) {
    case constants.FETCH_SND_TERRITORY_DETAILS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  countryDetails,
  clusterDetails,
  areaDetails,
  cbThanaDetails,
  selectedState,
  filteringState
});

export const getAllSndRegions = state => {
  if (state.user.snd.leftSidebar.countryDetails.regions)
    return state.user.snd.leftSidebar.countryDetails.regions;
  return [];
};

export const getAllSndAreas = state => {
  if (state.user.snd.leftSidebar.clusterDetails.areas)
    return state.user.snd.leftSidebar.clusterDetails.areas;
  return [];
};

export const getAllSndTerritories = state => {
  if (state.user.snd.leftSidebar.areaDetails.territories)
    return state.user.snd.leftSidebar.areaDetails.territories;
  return [];
};

export const getSndCountryDetails = state => {
  return state.user.snd.leftSidebar.countryDetails;
};

export const getSndRegionDetails = state => {
  return state.user.snd.leftSidebar.clusterDetails;
};

export const getSndAreaDetails = state => {
  return state.user.snd.leftSidebar.areaDetails;
};

export const getSndTerritoryDetails = state => {
  return state.user.snd.leftSidebar.cbThanaDetails;
};

export const getSelectedState = state => {
  return state.user.snd.leftSidebar.selectedState;
};

export const getFilteringState = state => {
  return state.user.snd.leftSidebar.filteringState;
};
